/**
 * Formats a list of strings into a comma-separated list with and/& before the last item.
 * Includes Oxford comma (comma after the second-to-last item).
 * This util not mutate original list.
 * This util does not format or otherwise modify items in the list.
 *
 * `WARNING: Localization is not supported.`
 */
export const readableList = (list: string[]) => {
  switch (list.length) {
    case 0:
      return "";
    case 1:
      return list[0];
    case 2: {
      return list.join(` & `);
    }
    default: {
      const copy = [...list];
      const last = copy.pop();
      return `${copy.join(", ")}, & ${last}`;
    }
  }
};
